import {Line, Rect, StyleSheet, Svg, Text, View} from "@react-pdf/renderer";
import React from "react";

interface SurgicalHistoryPdfProps {
    clientMedicalHistoryDetails: any;
    clientBasicDetails: any;
    surgicalHistoryOptionsList:any[]
}

const styles = StyleSheet.create({
    checkboxContainer: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 8,
    },
    checkbox: {
        width: 14,
        height: 14,
        marginRight: 10,
    },
    label: {
        fontSize: 10,
        flexWrap: "wrap",
    },
});

const Checkbox = ({checked}: { checked: boolean }) => (
    <Svg style={styles.checkbox} viewBox="0 0 14 14">
        <Rect x="1" y="1" width="12" height="12" stroke="#000" fill="white"/>
        {checked && (
            <>
                <Line x1="3" y1="7" x2="6" y2="10" stroke="#000" strokeWidth="1.5"/>
                <Line x1="6" y1="10" x2="11" y2="4" stroke="#000" strokeWidth="1.5"/>
            </>
        )}
    </Svg>
);

const SurgicalHistoryPdf = (props: SurgicalHistoryPdfProps) => {

    const {clientMedicalHistoryDetails, clientBasicDetails,surgicalHistoryOptionsList} = props;
    const selectedIds = clientMedicalHistoryDetails?.surgical_history?.questions || [];

    return (
        <View>
            {
                clientBasicDetails.gender === 'female' &&
                <View>
                    <Text
                        style={{
                            fontSize: 10,
                            paddingLeft: 12,
                            fontFamily: "Helvetica-Bold",
                            textDecoration: "underline",
                            textTransform: "uppercase",
                        }}
                    >
                        Females Only:
                    </Text>
                    <View style={{marginTop: 10}}>
                        <View style={{display: 'flex', flexDirection: 'row', marginBottom: 4, marginLeft: 20}}>
                            <Text style={{fontSize: 10}}>Are you currently pregnant or attempting to get
                                pregnant?</Text>
                            <Text style={{
                                fontSize: 10,
                                borderBottom: '1px solid black',
                                width:30,
                                marginLeft:20,
                                paddingLeft: 6

                            }}>{clientMedicalHistoryDetails?.females_only_questions["Pregnant or trying to get pregnant?"] || "N/A"}
                            </Text>
                        </View>

                        <View style={{display: 'flex', flexDirection: 'row', marginLeft: 20}}>
                            <Text style={{fontSize: 10}}>Are you currently nursing?</Text>
                            <Text style={{
                                fontSize: 10,
                                borderBottom: '1px solid black',
                                width:30,
                                marginLeft:10,
                                paddingLeft: 6
                            }}>{clientMedicalHistoryDetails?.females_only_questions["Nursing?"]}</Text>
                        </View>
                    </View>
                </View>

            }
            <Text
                style={{
                    fontSize: 10,
                    paddingLeft: 12,
                    fontFamily: "Helvetica-Bold",
                    textDecoration: "underline",
                    textTransform: "uppercase",
                    marginTop: 20,
                }}
            >
                Surgical History:
            </Text>
            <Text style={{paddingLeft: 20, fontSize: 10, paddingTop: 8, paddingBottom: 8}}>
                Have you ever had:
            </Text>
            <View
                style={{
                    border: "1px solid #000",
                    flexDirection: "row",
                    padding: 8,
                    marginLeft: 20,
                    width: "95%",
                }}
            >
                <View style={{width: "50%", paddingRight: 30}}>
                    {surgicalHistoryOptionsList?.slice(0, 9).map((option, index) => (
                        <View style={styles.checkboxContainer} key={option._id}>
                            <Checkbox checked={selectedIds.includes(option._id)}/>
                            <Text style={styles.label}>{option.title}</Text>
                        </View>
                    ))}
                    <View style={styles.checkboxContainer}>
                        <Checkbox checked={clientMedicalHistoryDetails?.surgical_history?.comments}/>
                        <Text style={styles.label}>Other Surgery not Listed</Text>
                    </View>
                    <View>
                        {clientMedicalHistoryDetails?.surgical_history?.comments &&
                            <View style={{fontSize: 10}}>
                                <View>{clientMedicalHistoryDetails?.surgical_history?.comments.split("\n").map((i: any, key: any) => {
                                    return <Text style={{marginLeft: 26}} key={key}>• {i}</Text>;
                                })}</View>
                            </View>}
                    </View>

                </View>
                <View style={{width: "50%"}}>
                    {surgicalHistoryOptionsList?.slice(9, 17).map((option, index) => (
                        <View style={styles.checkboxContainer} key={option._id}>
                            <Checkbox checked={selectedIds.includes(option._id)}/>
                            <Text style={styles.label}>{option.title}</Text>
                        </View>
                    ))}

                </View>
            </View>


        </View>
    );
}
export default SurgicalHistoryPdf;
